/**
 * Lazily load pdfmake + its ~2.4MB base64 font blob only when a PDF is
 * actually generated (not on component mount). See .docs/performance.md —
 * vfs_fonts.js is the single largest non-entry chunk in the app.
 *
 * The initialised instance is memoised across the whole session so the dynamic
 * import only runs once, no matter how many times (or from how many different
 * components) PDFs are produced.
 *
 * Usage:
 *   const pdfMake = await usePdfMake()
 *   pdfMake.createPdf(doc).open()
 */
let pdfMakePromise: Promise<any> | null = null

export function usePdfMake(): Promise<any> {
  if (!pdfMakePromise) {
    pdfMakePromise = (async () => {
      const [pdfMakeMod, pdfFontsMod] = await Promise.all([
        import('pdfmake/build/pdfmake'),
        import('pdfmake/build/vfs_fonts'),
      ])
      const pdfMake: any = (pdfMakeMod as any).default ?? pdfMakeMod
      const pdfFonts: any = (pdfFontsMod as any).default ?? pdfFontsMod
      pdfMake.addVirtualFileSystem(pdfFonts)
      return pdfMake
    })().catch((err) => {
      // Reset on failure so the next attempt can retry instead of reusing
      // a permanently-rejected promise.
      pdfMakePromise = null
      throw err
    })
  }
  return pdfMakePromise
}
